export default "__VITE_ASSET__C8YKebL0__"